import React from "react";
import { Stack } from "@mui/system";
import './projects.scss';

import photo from './pictures/projects.jpg';
import TitleAbout from "../../components/Title";
import Ouvidoria from '../../components/Ouvidoria';

import { Link } from "react-router-dom";

// projetos
import dipm from './pictures/dipm.jpg';
import s11d from './pictures/s11d.jpg';
import barcarena from './pictures/barcarena.png';
import paragominas from './pictures/paragominas.jpg';
import mineral from './pictures/mineral.jpg';
import drs from './pictures/capa.jpg'
import hse from './pictures/barcarena-hse.png';
import sossego from './pictures/sossego.jpg'
import peraFerroviaria from './pictures/pera_ferroviaria.jpg';
import barcarenaLogistica from './pictures/barcarena_logistica.jpg';
import projetoSossego from './pictures/projeto_sossego.jpg';
import projetoSalobo from './pictures/projeto_salobo.jpg';
import planta from './pictures/planta_beneficiamento.png';
import centroCultutal from './pictures/centro_cultural.jpg';
import oz from './pictures/oz.png';
import oreSorting from "./pictures/ore-sorting.jpg";
import SEO from "../../SEO/SEO";



export default function Projects(){

  const img = [dipm, s11d, barcarena, paragominas, mineral, drs, hse, sossego, peraFerroviaria, barcarenaLogistica, projetoSossego, projetoSalobo, planta, centroCultutal, oz, oreSorting ]

  return(
    <>
    <SEO title="Projetos - Séculos Engenharia e Serviços LTDA" link='https://seculosengenharia.com.br/projetos'/>
      <TitleAbout name="Projetos" link1={"Home/ "} link2={"Projetos"} />

      <section id="projects" className="projetos">
        <div className="container">
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="projects"
          >
            <div className="box-projects" 
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              <h1>Construindo o futuro <br/> com soluções inovadoras</h1>
              <p>Estamos sempre olhando para o futuro e buscando maneiras de criar soluções que ajudem nossos clientes a alcançar seus objetivos e construir um mundo melhor. 
                Combinamos conhecimento e experiência para entregar projetos de alta qualidade que atendem às necessidades únicas de cada cliente.
              </p>
            </div>
            <div className="box-projects"
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              <figure>
                <img src={photo} width="450" alt="img-projetos" className="img-fluid"/>
              </figure>
            </div>
          </Stack>
        </div>
      </section>

      <section id="projects-galery">
        <div className="container">
          <Stack
           directoin={{xs: 'column', sm: 'row'}}
           spacing={{xs: 1, sm: 2, md: 4}}
           className="galery"
          >
            <div className="title-projects">
              <h1
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">Conheça nossos projetos</h1>
              <p
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              Conheça os projetos que já realizamos e confira como podemos ajudá-lo a alcançar seus objetivos em seus projetos.
              </p>
            </div>

            {/* Section Projects */}
            <div className="section-projects">
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[0]} width="  250" height="350" alt="img-teste" />
                  <h2>APOIO À PESQUISA MINERAL</h2>
                  <Link to="/projetos/dipm">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[15]} width="  250" height="350" alt="img-teste" />
                  <h2>ORE SORTING</h2>
                  <Link to="/projetos/ore-sorting">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[1]} width="  350" height="350" alt="img-teste" />
                  <h2>S11D - VALE</h2>
                  <Link to="/projetos/s11d">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[5]} width="  350" height="350" alt="img-teste" />
                  <h2>BARCARENA - DRS</h2>
                  <Link to="/projetos/barcarena-drs">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[3]} width="  350" height="350" alt="img-teste" />
                  <h2>PARAGOMINAS</h2>
                  <Link to="projetos/paragominas">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[8]} width="  350" height="350" alt="img-teste" />
                  <h2>PERA FERROVIÁRIA - VALE</h2>
                  <Link to="/projetos/pera-ferroviaria">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[9]} width="  350" height="350" alt="img-teste" />
                  <h2>BARCARENA LOGÍSTICA</h2>
                  <Link to="/projetos/barcarena-logistica">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[6]} width="  350" height="350" alt="img-teste" />
                  <h2>BARCARENA - HSE</h2>
                  <Link to="/projetos/barcarena-hse">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[10]} width="  350" height="350" alt="img-teste" />
                  <h2>SOSSEGO - VALE</h2>
                  <Link to="/projetos/sossego-vale">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[11]} width="  350" height="350" alt="img-teste" />
                  <h2>SALOBO METAIS - VALE</h2>
                  <Link to="/projetos/salobo">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[13]} width="  350" height="350" alt="img-teste" />
                  <h2>CENTRO CULTURAL DE PARAUAPEBAS</h2>
                  <Link to="/projetos/centro-cultural">Saiba mais</Link>
                </div>
              </div>
              <div className="wrapper">
                <div className="box projects-services"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <img src={img[14]} width="  350" height="350" alt="img-teste" />
                  <h2>FACILITIES - OZ MINERALS</h2>
                  <Link to="/projetos/oz-minerals">Saiba mais</Link>
                </div>
              </div>
            </div>
          </Stack>

        </div>
      </section>

      <Ouvidoria/>
      
    </>
  )
}